import React, { useEffect } from 'react';
import {
    changeFrontAll,
    changeBackAll,
    changeSuiteRoomAll,
    changeFirstNameAll,
    changeMiddleNameAll,
    changeLastNameAll,
    changeCredentialsAll,
    changePrimaryTitleAll,
    changeTitle1All,
    changeTitle2All,
    changeTitle3All,
    changeSecondaryTitleAll,
    changeTitle4All,
    changeEmailAll,
    changeMainAll,
    changeDirectAll,
    changeCellAll,
    changeWebsiteAll,
    changeAddress2All,
    changePhoneLabel1All,
    changePhoneLabel2All,
    changePhoneLabel3All,
    changePhoneOtherLabel1All,
    changePhoneOtherLabel2All,
    changePhoneOtherLabel3All,
} from './../CanvasActions';
import TextField from './../Form/TextField';
import SelectField from './../Form/SelectField';

const FormP9 = React.memo((props) => {
    useEffect(() => {
        changeFrontAll(props.front);
    }, [props.front]);

    useEffect(() => {
        changeBackAll(props.back);
    }, [props.back]);

    useEffect(() => {
        changeSuiteRoomAll(props.suiteRoom);
    }, [props.suiteRoom]);

    useEffect(() => {
        changeFirstNameAll(props.firstName);
    }, [props.firstName]);

    useEffect(() => {
        changeMiddleNameAll(props.middleName);
    }, [props.middleName]);

    useEffect(() => {
        changeLastNameAll(props.lastName);
    }, [props.lastName]);

    useEffect(() => {
        changeCredentialsAll(props.credentials);
    }, [props.credentials]);

    useEffect(() => {
        changePrimaryTitleAll(props.primaryTitle);
    }, [props.primaryTitle]);

    useEffect(() => {
        changeTitle1All(props.title1);
    }, [props.title1]);

    useEffect(() => {
        changeTitle2All(props.title2);
    }, [props.title2]);

    useEffect(() => {
        changeTitle3All(props.title3);
    }, [props.title3]);

    useEffect(() => {
        changeSecondaryTitleAll(props.secondaryTitle);
    }, [props.secondaryTitle]);

    useEffect(() => {
        changeTitle4All(props.title4);
    }, [props.title4]);

    useEffect(() => {
        changeEmailAll(props.email);
    }, [props.email]);

    useEffect(() => {
        changeMainAll(props.main);
    }, [props.main]);

    useEffect(() => {
        changeDirectAll(props.direct);
    }, [props.direct]);

    useEffect(() => {
        changeCellAll(props.cell);
    }, [props.cell]);

    useEffect(() => {
        changeWebsiteAll(props.website);
    }, [props.website]);

    useEffect(() => {
        changeAddress2All(props.address2);
    }, [props.address2]);

    useEffect(() => {
        changePhoneLabel1All(props.phoneLabel1);
    }, [props.phoneLabel1]);

    useEffect(() => {
        changePhoneLabel2All(props.phoneLabel2);
    }, [props.phoneLabel2]);

    useEffect(() => {
        changePhoneLabel3All(props.phoneLabel3);
    }, [props.phoneLabel3]);

    useEffect(() => {
        changePhoneOtherLabel1All(props.phoneOtherLabel1);
    }, [props.phoneOtherLabel1]);

    useEffect(() => {
        changePhoneOtherLabel2All(props.phoneOtherLabel2);
    }, [props.phoneOtherLabel2]);

    useEffect(() => {
        changePhoneOtherLabel3All(props.phoneOtherLabel3);
    }, [props.phoneOtherLabel3]);

    const handleSetPhoneLabel1 = (event) => {
        props.setPhoneLabel1(event.target.value);
    };

    const handleSetPhoneLabel2 = (event) => {
        props.setPhoneLabel2(event.target.value);
    };

    const handleSetPhoneLabel3 = (event) => {
        props.setPhoneLabel3(event.target.value);
    };

    const handleSetPhoneOtherLabel1 = (event) => {
        props.setPhoneOtherLabel1(event.target.value);
    };

    const handleSetPhoneOtherLabel2 = (event) => {
        props.setPhoneOtherLabel2(event.target.value);
    };

    const handleSetPhoneOtherLabel3 = (event) => {
        props.setPhoneOtherLabel3(event.target.value);
    };

    let phoneOtherLabel1Field = null;
    if (props.phoneLabel1 === 'Other') {
        phoneOtherLabel1Field = (
            <input type="text" className="other-label" placeholder="Enter name" value={props.phoneOtherLabel1} onChange={handleSetPhoneOtherLabel1} />
        );
    }

    let phoneOtherLabel2Field = null;
    if (props.phoneLabel2 === 'Other') {
        phoneOtherLabel2Field = (
            <input type="text" className="other-label" placeholder="Enter name" value={props.phoneOtherLabel2} onChange={handleSetPhoneOtherLabel2} />
        );
    }

    let phoneOtherLabel3Field = null;
    if (props.phoneLabel3 === 'Other') {
        phoneOtherLabel3Field = (
            <input type="text" className="other-label" placeholder="Enter name" value={props.phoneOtherLabel3} onChange={handleSetPhoneOtherLabel3} />
        );
    }

    let frontField = (
        <SelectField
            required
            label="Select Front"
            value={props.front}
            setFunction={props.setFront}
            options={[
                { value: 1, label: 'White' },
                { value: 2, label: 'Grey' },
                { value: 3, label: 'Orange' },
                { value: 4, label: 'Gulf Blue' },
            ]}
        />
    );
    let suiteRoomField = (
        <TextField
            required
            label="Address, Suite"
            value={props.suiteRoom}
            setFunction={props.setSuiteRoom}
            placeholder="Enter your address"
        />
    );
    let cityStateZipField = (
        <TextField
            required
            label="City, State, Zip"
            value={props.address2}
            setFunction={props.setAddress2}
            placeholder="Enter your City, State, Zip"
        />
    );
    let firstNameField = (
        <TextField
            required
            label="First Name"
            value={props.firstName}
            setFunction={props.setFirstName}
            placeholder="Your First Name"
        />
    );
    let middleNameField = (
        <TextField
            label="MI"
            value={props.middleName}
            setFunction={props.setMiddleName}
            placeholder="Your Middle Initial"
        />
    );
    let lastNameField = (
        <TextField
            required
            label="Last Name"
            value={props.lastName}
            setFunction={props.setLastName}
            placeholder="Your Last Name"
        />
    );
    let credentialsField = (
        <TextField
            label="Credentials"
            value={props.credentials}
            setFunction={props.setCredentials}
            placeholder="Your Credentials"
        />
    );
    let primaryTitleField = (
        <TextField
            label="Primary Title"
            value={props.primaryTitle}
            setFunction={props.setPrimaryTitle}
            placeholder="Employee or Faculty Position"
        />
    );
    let title1Field = (
        <TextField
            label="Title 1"
            value={props.title1}
            setFunction={props.setTitle1}
            placeholder="Optional Title 1"
        />
    );
    let title2Field = (
        <TextField
            label="Title 2"
            value={props.title2}
            setFunction={props.setTitle2}
            placeholder="Optional Title 2"
        />
    );
    let title3Field = (
        <TextField
            label="Title 3"
            value={props.title3}
            setFunction={props.setTitle3}
            placeholder="Optional Title 3"
        />
    );
    let secondaryTitleField = (
        <TextField
            label="Secondary Title"
            value={props.secondaryTitle}
            setFunction={props.setSecondaryTitle}
            placeholder="Title for other School/Unit affiliation"
        />
    );
    let title4Field = (
        <TextField
            label="Title Line"
            value={props.title4}
            setFunction={props.setTitle4}
            placeholder="School/Institute affiliation for secondary title"
        />
    );
    let emailField = (
        <TextField
            required
            label="Email"
            value={props.email}
            setFunction={props.setEmail}
            placeholder="Your Email Address"
        />
    );
    let mainField = (
        <div className="variable">
            <div className="label">
                <select className="select-label" value={props.phoneLabel1} onChange={handleSetPhoneLabel1}>
                    <option value="Main">Main</option>
                    <option value="Direct">Direct</option>
                    <option value="Cell">Cell</option>
                    <option value="Fax">Fax</option>
                    <option value="Other">Other</option>
                </select>
                &nbsp;:
                {phoneOtherLabel1Field}
            </div>
            <TextField
                isPhone
                showLabel={false}
                phoneFormat={3}
                label="Main"
                value={props.main}
                setFunction={props.setMain}
                placeholder="Phone number"
            />
        </div>
    );
    let directField = (
        <div className="variable">
            <div className="label">
                <select className="select-label" value={props.phoneLabel2} onChange={handleSetPhoneLabel2}>
                    <option value="Main">Main</option>
                    <option value="Direct">Direct</option>
                    <option value="Cell">Cell</option>
                    <option value="Fax">Fax</option>
                    <option value="Other">Other</option>
                </select>
                &nbsp;:
                {phoneOtherLabel2Field}
            </div>
            <TextField
                isPhone
                showLabel={false}
                phoneFormat={3}
                label="Direct"
                value={props.direct}
                setFunction={props.setDirect}
                placeholder="Phone number"
            />
        </div>
    );
    let cellField = (
        <div className="variable">
            <div className="label">
                <select className="select-label" value={props.phoneLabel3} onChange={handleSetPhoneLabel3}>
                    <option value="Main">Main</option>
                    <option value="Direct">Direct</option>
                    <option value="Cell">Cell</option>
                    <option value="Fax">Fax</option>
                    <option value="Other">Other</option>
                </select>
                &nbsp;:
                {phoneOtherLabel3Field}
            </div>
            <TextField
                isPhone
                showLabel={false}
                phoneFormat={3}
                label="Cell"
                value={props.cell}
                setFunction={props.setCell}
                placeholder="Phone number"
            />
        </div>
    );
    let websiteField = (
        <TextField
            label="Web/URL"
            value={props.website}
            setFunction={props.setWebsite}
            placeholder="Web Address"
        />
    );

    if (props.templateCode === 'p9t3') {
        frontField = (
            <SelectField
                required
                label="Select Front"
                value={props.front}
                setFunction={props.setFront}
                options={[
                    { value: 1, label: 'White' },
                    { value: 2, label: 'Grey' },
                ]}
            />
        );
    }

    let title = '';
    if (props.templateCode === 'p9t1') {
        title = 'UTHealth Houston | Cizik School of Nursing Business Card';
    } else if (props.templateCode === 'p9t2') {
        title = 'UTHealth Houston | McGovern Medical School Business Card';
    } else if (props.templateCode === 'p9t3') {
        title = 'MD Anderson Cancer Center | UTHealth Houston Graduate School Business Card';
    } else if (props.templateCode === 'p9t4') {
        title = 'UTHealth Houston | School of Biomedical Informatics Business Card';
    } else if (props.templateCode === 'p9t5') {
        title = 'UTHealth Houston | School of Dentistry Business Card';
    } else if (props.templateCode === 'p9t6') {
        title = 'UTHealth | School of Public Health Business Card';
    } else if (props.templateCode === 'p9t7') {
        title = 'UTHealth Houston General Card Business Card';
    } else if (props.templateCode === 'p9t8') {
        title = 'UTHealth Houston with Social Media Handles Business Card';
    } else if (props.templateCode === 'p9t9') {
        title = 'UTHealth Houston | UTHealth Services Business Card';
    } else if (props.templateCode === 'p9t10') {
        title = 'UTHealth Houston | UTHealth Behavioral Sciences Business Card';
    } else if (props.templateCode === 'p9t11') {
        title = 'UTHealth Houston | McWilliams School of Biomedical Informatics Business Card';
    } else if (props.templateCode === 'p9t12') {
        title = 'UTHealth Houston | School of Public Health Business Card';
    }

    let backField = null;
    if (props.templateCode === 'p9t1') {
        directField = (
            <div className="variable">
                <div className="label">
                    <select className="select-label" value={props.phoneLabel2} onChange={handleSetPhoneLabel2}>
                        <option value="Main">Main</option>
                        <option value="Direct">Direct</option>
                        <option value="Cell">Cell</option>
                        <option value="Fax">Fax</option>
                        <option value="Other">Other</option>
                    </select>
                    &nbsp;:
                    {phoneOtherLabel2Field}
                </div>
                <TextField
                    isPhone
                    showLabel={false}
                    phoneFormat={3}
                    label="Direct"
                    value={props.direct}
                    setFunction={props.setDirect}
                    placeholder="Phone number"
                />
            </div>
        );
    } else if (props.templateCode === 'p9t9') {
        backField = (
            <SelectField
                required
                label="Select Type"
                value={props.back}
                setFunction={props.setBack}
                options={[
                    { value: 1, label: 'Business Card Back' },
                    { value: 2, label: 'Appointment Card Back' },
                ]}
            />
        );

        if (parseInt(props.back) === 2) {
            firstNameField = null;
            middleNameField = null;
            lastNameField = null;
            credentialsField = null;
            primaryTitleField = null;
            title1Field = null;
            title2Field = null;
            title3Field = null;
            secondaryTitleField = null;
            title4Field = null;
            emailField = null;
            mainField = null;
            directField = null;
            cellField = null;
            websiteField = null;
        }
    } else if (props.templateCode === 'p9t10') {
        firstNameField = null;
        middleNameField = null;
        lastNameField = null;
        credentialsField = null;
    }

    return (
        <form action="">
            <hr />
            {frontField}
            {suiteRoomField}
            {cityStateZipField}
            {backField}
            <hr />
            {firstNameField}
            {middleNameField}
            {lastNameField}
            {credentialsField}
            {firstNameField || middleNameField || lastNameField || credentialsField ? <hr /> : null}
            {primaryTitleField}
            {title1Field}
            {title2Field}
            {title3Field}
            {primaryTitleField || title1Field || title2Field || title3Field ? <hr /> : null}
            {secondaryTitleField}
            {title4Field}
            {secondaryTitleField || title4Field ? <hr /> : null}
            {emailField}
            {mainField}
            {directField}
            {cellField}
            {websiteField}
            {emailField || mainField || directField || cellField || websiteField ? <hr /> : null}
            <SelectField
                required
                label="Quantity"
                value={props.quantity}
                setFunction={props.setQuantity}
                options={[
                    { value: '', label: 'Select option' },
                    { value: '250', label: '250' },
                    { value: '500', label: '500' },
                    { value: '1000', label: '1000' },
                ]}
            />
            <hr />
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> {title}</div>
                <div className="description-list">
                    <span className="label">Description:</span>
                    <ul>
                        <li>Flat: 3" x 2.5"</li>
                        <li>Stock: 100# Cougar Opaque White Cover</li>
                        <li>Double sided </li>
                    </ul>
                </div>
            </div>
        </form>
    );
});

export default FormP9;
